import { GLAdjustment } from './glAdjustment.model';
export class GLAdjustmentStage extends GLAdjustment {
  constructor(
    public glCode: string,
    public glPolicyCode: string,
    public glPolicyDescription: string,
    public amount: number,
  ) {
    super(glCode, glPolicyCode, amount);
  }
}



// WEBPACK FOOTER //
// ./src/app/models/glAdjustmentStage.model.ts